import React, { Component } from 'react'
import ProfilePicture from 'components/profile/profile-picture'

import SmoothCollapse from 'react-smooth-collapse'

import {
    safelyFormatText
} from 'utils'

class CommmentReplyNotice extends Component {
    state = {
        comment: null,
        isOpen: false
    }

    UNSAFE_componentWillUpdate = nextProps => {
        if (nextProps.comment) {
            if (!this.props.comment || this.props.comment.id !== nextProps.comment.id) {
                this.setState({
                    comment: nextProps.comment
                })

                setTimeout(_ => {
                    this.setState({
                        isOpen: true
                    })
                }, 1)
            }
        }

        if (this.props.comment && !nextProps.comment) {
            this.setState({
                isOpen: false
            })
        }
    }

    getCommentUserName = _ => {
        const {
            allUsers,
        } = this.props

        const comment = this.state.comment ? this.state.comment : this.props.comment

        const user = allUsers[comment.user_id] || allUsers[comment.sender_id]

        if (user) {
            return user.first_name
        }

        return ''
    }

    render() {
        const {
            cancelReplyEntity,
            thisUser
        } = this.props

        const {
            isOpen
        } = this.state

        const comment = this.state.comment ? this.state.comment : this.props.comment

        const commentText = (() => {
            if (!comment) {
                return ''
            }

            if (comment.text) {
                return safelyFormatText(comment.text)
            }

            if (comment.message_text) {
                return safelyFormatText(comment.message_text)
            }

            return ''
        })()

        return (
            <div className="comment-reply-notice">
                <SmoothCollapse
                    expanded={isOpen}
                    allowOverflowWhenOpen={true}
                >
                    {comment ?
                        <div className="comment-reply-notice-inner">
                            <h3>
                                {thisUser.id === comment.user_id ?
                                    <span>
                                        Replying to <strong>your own</strong> comment:
                                    </span>
                                    :
                                    <span>
                                        Replying to <strong>{this.getCommentUserName()}</strong>'s comment:
                                    </span>
                                }
                                <button
                                    className="close-modal"
                                    onClick={cancelReplyEntity}
                                >
                                    &times;
                                </button>
                            </h3>
                            <div className="message-content">
                                <div dangerouslySetInnerHTML={{ __html: commentText }} />
                            </div>
                        </div>
                        :
                        <div>
                            <h2>
                                HMMMMM
                            </h2>
                        </div>
                    }
                </SmoothCollapse>
            </div>
        )
    }
}

export default CommmentReplyNotice